import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { type ContextMenuOnClickParams } from '../types/context-menu-onclick.type';
import { DisplayMode } from '@r-core';

export const displayModeMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Group,
		title: 'Display Mode',
		items: [
			{
				type: ContextMenuListItemType.Item,
				content: 'Overhead',
				onClick: ({ controller }: ContextMenuOnClickParams): void => {
					controller.navigation.displayMode = DisplayMode.Overhead;
				}
			},
			{
				type: ContextMenuListItemType.Item,
				content: 'Inline',
				onClick: ({ controller }: ContextMenuOnClickParams): void => {
					controller.navigation.displayMode = DisplayMode.Inline;
				}
			}
		]
	};
};
